/* eslint-disable @typescript-eslint/naming-convention */
import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { Data } from "../../../store/possoftware/types";
import { MRT_ColumnDef, MaterialReactTable } from "material-react-table";
import TableActions from "../../../common/table/TableActions";

interface Props {
  posSoftwareData?: Data[];
}

interface RowData {
  id: string;
  ApplicationName: string;
  ProviderIdentification: string;
}

const mapDataToTable = (pos: Data[]): RowData[] => {
  return pos.map((data) => {
    return {
      id: data.id,
      ApplicationName: data.attributes.ApplicationName,
      ProviderIdentification: data.attributes.ProviderIdentification,
    };
  });
};

export default function PosSoftwareTable({ posSoftwareData }: Props) {
  const history = useHistory();
  const data = mapDataToTable(posSoftwareData);

  const viewAction = (rowData: RowData) => {
    history.push(`/possoftware/view/${rowData.id}`);
  };

  const editAction = (rowData: RowData) => {
    history.push(`/possoftware/edit/${rowData.id}`);
  };

  const columns = useMemo<MRT_ColumnDef<RowData>[]>(
    () => [
      {
        header: "Application",
        accessorKey: "ApplicationName",
      },
      {
        header: "Provider",
        accessorKey: "ProviderIdentification",
      },
    ],
    []
  );

  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      getRowId={(row) => row.id}
      initialState={{
        showGlobalFilter: true,
        showColumnFilters: false,
        density: "spacious",
      }}
      enableColumnActions={false}
      enableDensityToggle={false}
      enableFullScreenToggle={false}
      enableColumnFilters={false}
      enableHiding={false}
      enableRowActions
      muiTablePaginationProps={{
        rowsPerPageOptions: [5, 10, 20],
      }}
      displayColumnDefOptions={{
        "mrt-row-actions": {
          header: "",
          size: 100,
        },
      }}
      positionActionsColumn="last"
      renderRowActions={({ row }) => (
        <TableActions
          section="POSSoftware"
          onView={() => viewAction(row.original)}
          onEdit={() => editAction(row.original)}
        />
      )}
    />
  );
}
